import type { EntityStatusTone } from '../../../components/entity-detail/EntityStatusChip.js';
// Подписи и цвета статуса встречи — один источник для грида и карточки.
// Раньше карты жили внутри `MeetingsPage`, и у карточки не было к ним доступа.
import type { CSSProperties } from 'react';
import type { MeetingParticipant, MeetingStatus } from '../api/meetings.client.js';
import { i18n } from '../../../i18n/index.js';
import { formatPersonName } from '../../../shared/format/index.js';

export const STATUS_LABEL: Record<MeetingStatus, string> = {
  get scheduled() {
    return i18n.t('crm.features.meeting.status.scheduled');
  },
  get completed() {
    return i18n.t('crm.features.meeting.status.completed');
  },
  get cancelled() {
    return i18n.t('crm.features.meeting.status.cancelled');
  },
};

export const STATUS_TONE: Record<MeetingStatus, EntityStatusTone> = {
  scheduled: 'processing',
  completed: 'success',
  cancelled: 'default',
};

/** Порядок статусов для сортировки: сначала предстоящие, отменённые — в конце. */
export const STATUS_ORDER: readonly MeetingStatus[] = ['scheduled', 'completed', 'cancelled'];

/** Подпись участника: сотрудник, контакт или внешний гость. */
export function meetingParticipantLabel(participant: MeetingParticipant): string {
  if (participant.member) return participant.member.user.name || participant.member.user.email;
  if (participant.contact) {
    return formatPersonName(participant.contact.firstName, participant.contact.lastName);
  }
  return (
    participant.guestName ||
    participant.guestEmail ||
    i18n.t('crm.features.features.meetings.pages.meetingspage.гость')
  );
}

/** Spec D-пилюли участников: soft-tinted token surfaces, не antd-пресеты. */
export function meetingParticipantTagStyle(participant: MeetingParticipant): CSSProperties {
  if (participant.member) {
    return {
      background: 'var(--ant-color-primary-bg)',
      color: 'var(--ant-color-primary-text)',
      borderColor: 'var(--ant-color-primary-border)',
      marginInlineEnd: 0,
    };
  }
  if (participant.contact) {
    return {
      background: 'var(--ant-color-success-bg)',
      color: 'var(--ant-color-success-text)',
      borderColor: 'var(--ant-color-success-border)',
      marginInlineEnd: 0,
    };
  }
  return {
    background: 'var(--g-fill)',
    color: 'var(--ant-color-text-secondary)',
    borderColor: 'transparent',
    marginInlineEnd: 0,
  };
}
